/**
 * Latency modes.
 */
export enum MKLatencyMode {
    /**
     * The player is behind the target latency and performing catchup.
     */
    Catchup = "catchup",

    /**
     * The player is ahead of the target latency and performing fallback.
     */
    Fallback = "fallback",

    /**
     * The player is playing at the target latency.
     */
    Idle = "idle",

    /**
     * Controlling the latency is temporarily disabled due to not playing at the live edge or a user-defined playback speed (i.e. unequal to 1) being set.
     */
    Suspended = "suspended"
}